import { Skeleton } from "@apex/component-library";
import { Box, Stack } from "@chakra-ui/react";

import { useGetCallsAndAlerts } from "../api/useGetCallsAndAlerts";
import CallsAlertsResultsGrid from "../components/CallsAlertsResultsGrid";
import CallsAlertsSearchBar from "../components/CallsAlertsSearchBar";
import { withPermissions } from "../hoc/withPermissions";
import { Permissions } from "../permissions";

const CallsAlertsPage = () => {
  const { data: getCallsData, isFetching } = useGetCallsAndAlerts();

  return (
    <Stack spacing={0} overflow="auto" flex="1 1 0" height="100%">
      <Box>
        <CallsAlertsSearchBar />
      </Box>
      <Skeleton
        isLoaded={!isFetching}
        overflow="auto"
        h="100%"
        data-testid="calls-skeleton"
      >
        <Box width="100%" overflow="auto" height="100%">
          {!isFetching && getCallsData && getCallsData.records && (
            <CallsAlertsResultsGrid searchResults={getCallsData.records} />
          )}
        </Box>
      </Skeleton>
    </Stack>
  );
};

export default withPermissions(CallsAlertsPage, [
  Permissions.AccountRead,
  Permissions.MarginProcessingUiNavView,
]);
